import { EventEmitter, Injectable } from '@angular/core';
import { DialogService } from 'app/shared/ui/dialog/dialog.service';
import { FileUploaderComponent } from 'app/dialogs/file-uploader/file-uploader.component';
import { HttpErrorResponse } from '@angular/common/http';
import { MatDialogRef } from '@angular/material/dialog';
import { DialogComponent } from 'app/shared/ui/dialog/dialog.component';

export interface IFileUploaderParams {
  buttonLabel: string;
  requestUri: string;
  accept: string | string[];
  showDropZone: boolean;
  dialogTitle: string;
  param: string;
  allowMultiple?: boolean;
  maxFiles?: number;
  maxFileSize?: string | number;
  extraParams?: { [key: string]: any };
  onComplete: (responses: any) => void;
  onError: (errors: HttpErrorResponse) => void;
  showWarnings?: boolean;
  customWarning?: string;
}

export class FileUploaderInstance {
  public onComplete: EventEmitter<any>;

  public onError: EventEmitter<HttpErrorResponse>;
  public onUploadComplete: EventEmitter<any> = new EventEmitter<any>();

  constructor() {
    this.onComplete = new EventEmitter<any>();
    this.onError = new EventEmitter<HttpErrorResponse>();
  }
}

@Injectable({
  providedIn: 'root',
})
export class FileUploaderService {
  private instance$: FileUploaderInstance;

  private dialogInstance: MatDialogRef<DialogComponent>;

  private completeHandler: (responses: any) => void;

  private errorHandler: (errors: HttpErrorResponse) => void;

  private pickerParams: IFileUploaderParams;

  constructor(private dialogService: DialogService) {
  }

  init(params: IFileUploaderParams): FileUploaderInstance {
    this.instance$ = new FileUploaderInstance();

    if (params.onComplete) {
      this.completeHandler = params.onComplete;
      this.instance$.onComplete.subscribe(result =>
        this.onUploadComplete(result),
      );
    }

    if (params.onError) {
      this.errorHandler = params.onError;
      this.instance$.onError.subscribe(errors => this.onUploadError(errors));
    }

    this.pickerParams = params;

    return this.instance$;
  }

  selectFile() {
    if (!this.instance$) {
      throw Error('Please, Initialize the service first');
    }

    this.dialogInstance = this.dialogService.openDialog({
      content: FileUploaderComponent,
      componentData: {
        accept: this.pickerParams.accept,
        buttonLabel: this.pickerParams.buttonLabel,
        requestUri: this.pickerParams.requestUri,
        showDropZone: this.pickerParams.showDropZone,
        complete: this.instance$.onComplete,
        error: this.instance$.onError,
        param: this.pickerParams.param,
        extraParams: this.pickerParams.extraParams,
        allowMultiple: this.pickerParams.allowMultiple,
        maxFiles: this.pickerParams.maxFiles,
        maxFileSize: this.pickerParams.maxFileSize,
        showWarnings: this.pickerParams.showWarnings === undefined ? true : this.pickerParams.showWarnings,
        customWarning: this.pickerParams.customWarning,
      },
      title: this.pickerParams.dialogTitle,
      dialogMinWidth: '700px',
      canClose: true,
    });
  }

  onUploadComplete(responses: any[]) {
    if (this.dialogInstance) {
      this.dialogInstance.close();
    }

    if (this.completeHandler) {
      this.completeHandler(responses);
    }
  }

  onUploadError(errors: HttpErrorResponse) {
    if (this.errorHandler) {
      this.errorHandler(errors);
    }
  }
}
